import React, { useState } from 'react';
import { useAppSelector } from '../../store/reducers/store';
import { Box, ITheme, Pagination, PaginationItem, useTheme } from '@mui/material';
import InvestorsListItem from './InvestorsListItem';
import { Utilities } from '../../utility/utils';

const InvestorsList: React.FC = () => {
    const [page, setPage] = useState(0);
    const itemPerPage = 10;
    const theme = useTheme() as ITheme;
    const colors = Utilities.shuffleArray(Object.keys(theme.palette.leo).filter(k => k.indexOf("color")!== -1).map(k => (theme.palette.leo as any)[k]));

    const investors = useAppSelector(state => state.portfolioDetails.portfolio?.investors);
    if (investors === undefined){
        return <></>;
    }

    return <Box display={"flex"} flexDirection={"column"} gap={"30px"} alignItems={"center"} paddingBottom={"20px"}>
        <Box display={"flex"} flexWrap={"wrap"} gap={"30px 49px"}>
            {investors.slice(itemPerPage*page, itemPerPage*(page+1)).map((i, index) => <InvestorsListItem investor={i} key={`investor-${i.id}`} color={colors[(itemPerPage * page + index)%colors.length]} />)}
        </Box>
        <Pagination page={page+1} count={Math.floor((investors.length+(itemPerPage - 1))/itemPerPage)} color='primary' onChange={(props, value) => setPage(value - 1)}
            hideNextButton hidePrevButton renderItem={(item) => (
                <PaginationItem {...item} sx={{ fontSize: "16px", fontWeight:"400" , "&.Mui-selected": { backgroundColor: item.selected ? theme.palette.common.white : undefined, boxShadow: theme.shadows[1]}}} />
                )}/>
    </Box>;
}

export default InvestorsList